<div class="up">
  <header class="up-fej">
    <div>
      <h1>Könyvelésem</h1>
      <span class="up-alcim">A cég könyvelése és bérszámfejtése – olvasásra, a könyvelő adataiból</span>
    </div>
    <span class="up-ter"></span>
    <select *ngIf="forrasok.length > 1" [ngModel]="forras" (ngModelChange)="valt($event)">
      <option *ngFor="let f of forrasok" [ngValue]="f">{{ f.nev }}{{ f.konyvelo ? ' · ' + f.konyvelo : '' }}</option>
    </select>
    <select [(ngModel)]="ev" (ngModelChange)="frissit()"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
    <button type="button" class="up-vissza" (click)="router.navigateByUrl('/')">Vissza</button>
  </header>

  <div class="up-ures" *ngIf="!betolt && !forrasok.length">
    Még nincs megnyitható könyvelés. Ha a könyvelőiroda ugyanezt a rendszert használja, ő ad hozzáférést a cég adatlapján;
    ha másik rendszeren könyvel, kapcsolati kódot ad – azt itt lent kell megadni.
  </div>
  <!--  Két installáció: a könyvelőiroda kapcsolati kódja („Könyvelés” / „Bérszámfejtés” adatkör). -->
  <details class="up-kod" [open]="!betolt && !forrasok.length">
    <summary>Kapcsolati kód megadása (ha a könyvelő másik rendszeren dolgozik)</summary>
    <div class="up-kod-sor">
      <input [(ngModel)]="kod" placeholder="pl. FP7UH-7SH4-B4CK-ZLE2-R57V" spellcheck="false">
      <input *ngIf="kezi" [(ngModel)]="url" placeholder="a könyvelő rendszerének címe (https://…)">
      <button type="button" (click)="csatlakozik()" [disabled]="fut || !kod.trim()">Kapcsolódás</button>
      <button type="button" class="up-link" (click)="kezi = !kezi">{{ kezi ? 'cím nélkül' : 'cím megadása' }}</button>
    </div>
    <div class="up-hiba" *ngIf="kodHiba">{{ kodHiba }}</div>
  </details>

  <ng-container *ngIf="forras">
    <div class="up-cim"><b>{{ forras.nev }}</b><span *ngIf="forras.konyvelo"> · könyvelő: {{ forras.konyvelo }}</span>
      <span class="up-figy" *ngIf="forras.figyelmeztetes">{{ forras.figyelmeztetes }}</span></div>
    <nav class="up-fulek">
      <button type="button" *ngIf="van('konyveles')" [class.aktiv]="ful === 'attekintes'" (click)="fulValt('attekintes')">Áttekintés</button>
      <button type="button" *ngIf="van('konyveles')" [class.aktiv]="ful === 'bevallasok'" (click)="fulValt('bevallasok')">Bevallások</button>
      <button type="button" *ngIf="van('berszamfejtes')" [class.aktiv]="ful === 'ber'" (click)="fulValt('ber')">Bér</button>
    </nav>
    <div class="up-hiba" *ngIf="hiba">{{ hiba }}</div>
    <div class="up-halvany" *ngIf="fut">Betöltés…</div>

    <!-- ÁTTEKINTÉS -->
    <ng-container *ngIf="ful === 'attekintes' && a && !fut">
      <div class="up-kartyak">
        <div class="up-kartya"><span>Eredmény {{ a.ev }}</span><b [class.neg]="a.eredmeny[11]?.gongyolt < 0">{{ a.eredmeny[11]?.gongyolt | number:'1.0-0' }} Ft</b>
          <small>{{ modNev(a.ceg.konyveles_mod) }}</small></div>
        <div class="up-kartya" *ngIf="a.nyitott?.vevo"><span>Kintlévőség (vevők)</span><b>{{ a.nyitott.vevo.osszeg | number:'1.0-0' }} Ft</b>
          <small>{{ a.nyitott.vevo.db }} tétel · lejárt: {{ a.nyitott.vevo.lejart | number:'1.0-0' }} Ft</small></div>
        <div class="up-kartya" *ngIf="a.nyitott?.szallito"><span>Tartozás (szállítók)</span><b>{{ a.nyitott.szallito.osszeg | number:'1.0-0' }} Ft</b>
          <small>{{ a.nyitott.szallito.db }} tétel · lejárt: {{ a.nyitott.szallito.lejart | number:'1.0-0' }} Ft</small></div>
        <div class="up-kartya" *ngIf="a.adoszamla"><span>Adófolyószámla</span><b [class.neg]="a.adoszamla.osszesen > 0">{{ a.adoszamla.osszesen | number:'1.0-0' }} Ft</b>
          <small>NAV-lekérdezés: {{ a.adoszamla.utolso_szinkron | date:'yyyy.MM.dd.' }}</small></div>
      </div>

      <h3>Havi eredmény</h3>
      <table class="up-tabla">
        <thead><tr><th>Hónap</th><th class="j">Bevétel</th><th class="j">Kiadás / költség</th><th class="j">Eredmény</th><th class="j">Göngyölt</th></tr></thead>
        <tbody><tr *ngFor="let h of a.eredmeny"><td>{{ honapok[h.ho - 1] }}</td><td class="j">{{ h.bevetel | number:'1.0-0' }}</td><td class="j">{{ h.kiadas | number:'1.0-0' }}</td>
          <td class="j" [class.neg]="h.eredmeny < 0">{{ h.eredmeny | number:'1.0-0' }}</td><td class="j" [class.neg]="h.gongyolt < 0">{{ h.gongyolt | number:'1.0-0' }}</td></tr></tbody>
      </table>

      <ng-container *ngIf="a.befizetendo?.length">
        <h3>Befizetendő adók és járulékok (e hónap)</h3>
        <table class="up-tabla">
          <thead><tr><th>Adónem</th><th>Határidő</th><th>Számlaszám</th><th class="j">Összeg</th></tr></thead>
          <tbody><tr *ngFor="let t of a.befizetendo"><td>{{ t.adonem || t.feladat }}</td><td>{{ t.hatarido }}</td><td class="szam">{{ t.iban || t.szamla }}</td><td class="j">{{ t.osszeg | number:'1.0-0' }} Ft</td></tr></tbody>
        </table>
      </ng-container>

      <ng-container *ngIf="a.adoszamla?.adonemek?.length">
        <h3>Adófolyószámla adónemenként</h3>
        <table class="up-tabla">
          <thead><tr><th>Adónem</th><th>Minősítés</th><th class="j">Egyenleg</th></tr></thead>
          <tbody><tr *ngFor="let x of a.adoszamla.adonemek"><td>{{ x.kod }} {{ x.megnevezes }}</td><td>{{ x.minosites }}</td><td class="j">{{ x.egyenleg | number:'1.0-0' }} Ft</td></tr></tbody>
        </table>
      </ng-container>
    </ng-container>

    <!-- BEVALLÁSOK -->
    <ng-container *ngIf="ful === 'bevallasok' && b && !fut">
      <h3>A NAV-hoz beküldött bevallások</h3>
      <table class="up-tabla" *ngIf="b.nav.length">
        <thead><tr><th>Bevallás</th><th>Időszak</th><th>Benyújtva</th><th>Állapot</th><th></th></tr></thead>
        <tbody><tr *ngFor="let r of b.nav"><td>{{ r.kod }} {{ r.nev }}<small *ngIf="r.javitas"> · javító</small></td><td>{{ r.idoszak || (r.tol + ' – ' + r.ig) }}</td>
          <td>{{ r.benyujtva }}</td><td>{{ r.allapot }}</td><td><button type="button" class="up-pdf" *ngIf="r.van_pdf" (click)="pdf(r)">PDF</button></td></tr></tbody>
      </table>
      <div class="up-halvany" *ngIf="!b.nav.length">Erre az évre nincs letöltött bevallás.</div>
      <ng-container *ngIf="b.sajat.length">
        <h3>A könyvelő által készített bevallások</h3>
        <table class="up-tabla">
          <thead><tr><th>Bevallás</th><th>Időszak</th><th>Állapot</th><th>Beküldve</th></tr></thead>
          <tbody><tr *ngFor="let r of b.sajat"><td>{{ r.kod }} {{ r.cim }}<small> · {{ r.modul === 'BER' ? 'bér' : 'könyvelés' }}</small></td>
            <td>{{ r.ev }}{{ r.ho ? '. ' + honapok[r.ho - 1] : '' }}{{ r.negyedev ? '. ' + r.negyedev + '. negyedév' : '' }}</td><td>{{ r.allapot }}</td><td>{{ r.bekuldve }}</td></tr></tbody>
        </table>
      </ng-container>
    </ng-container>

    <!-- BÉR -->
    <ng-container *ngIf="ful === 'ber' && ber && !fut">
      <div class="up-halvany" *ngIf="!ber.van_ber">A cégnek nincs bérszámfejtése ennél a könyvelőnél.</div>
      <table class="up-tabla" *ngIf="ber.honapok?.length">
        <thead><tr><th>Hónap</th><th class="j">Létszám</th><th class="j">Bruttó</th><th class="j">Nettó</th><th class="j">SZJA</th><th class="j">TB-járulék</th><th class="j">Szocho</th><th class="j">Munkáltatói költség</th></tr></thead>
        <tbody>
          <tr *ngFor="let h of ber.honapok"><td>{{ honapok[h.ho - 1] }}<small *ngIf="h.tervezet"> · tervezet</small></td><td class="j">{{ h.fo }}</td>
            <td class="j">{{ h.brutto | number:'1.0-0' }}</td><td class="j">{{ h.netto | number:'1.0-0' }}</td><td class="j">{{ h.szja | number:'1.0-0' }}</td>
            <td class="j">{{ h.tb_jarulek | number:'1.0-0' }}</td><td class="j">{{ h.szocho | number:'1.0-0' }}</td><td class="j">{{ h.munkaltatoi_koltseg | number:'1.0-0' }}</td></tr>
          <tr class="ossz"><td>Összesen</td><td></td><td class="j">{{ osszeg(ber.honapok, 'brutto') | number:'1.0-0' }}</td><td class="j">{{ osszeg(ber.honapok, 'netto') | number:'1.0-0' }}</td>
            <td class="j">{{ osszeg(ber.honapok, 'szja') | number:'1.0-0' }}</td><td class="j">{{ osszeg(ber.honapok, 'tb_jarulek') | number:'1.0-0' }}</td>
            <td class="j">{{ osszeg(ber.honapok, 'szocho') | number:'1.0-0' }}</td><td class="j">{{ osszeg(ber.honapok, 'munkaltatoi_koltseg') | number:'1.0-0' }}</td></tr>
        </tbody>
      </table>
      <div class="up-halvany" *ngIf="ber.van_ber && !ber.honapok?.length">Erre az évre nincs számfejtés.</div>
    </ng-container>
  </ng-container>
</div>
